import { render, staticRenderFns } from "./InstructionsStep.vue?vue&type=template&id=24d0e08a&scoped=true"
import script from "./InstructionsStep.vue?vue&type=script&lang=js"
export * from "./InstructionsStep.vue?vue&type=script&lang=js"
import style0 from "./InstructionsStep.vue?vue&type=style&index=0&id=24d0e08a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d0e08a",
  null
  
)

export default component.exports